// Co-Authored-By: AI-Assisted | updated: 2026-10-10 10:05:48
import { useEffect, useState } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import { Badge } from 'antd';
import NoticeHeader from '@/component/notice/header';
import { STATIC_RESOURCE } from '@/utils/tools';
import { useI18n } from '@/i18n';
import useSupplierApplyModal from '@/hooks/useSupplierApplyModal';
import { AUTH_PAGES } from '@/constants/paths';
import { storage } from '@/utils/storage';
import PortalMenu from '../portalMenu';

export default function Index() {
  const { open, SupplierApplyModal } = useSupplierApplyModal();
  const navigate = useNavigate();
  const location = useLocation();
  const $t = useI18n('component.header.language');
  const [companyRole, setCompanyRole] = useState();
  const [roleText, setRoleText] = useState($t('Supplier Center'));
  const token = storage.get('token');
  const company_info = useSelector(state => state.lang.company_info) || {};
  const user_info = useSelector(state => state.lang.user_info) || {};
  const { cartList } = useSelector((state) => ({ cartList: state.cart?.list || [] }), shallowEqual);
  const formatList = cartList.reduce((prev, next) => [...prev, ...next.sale_list], []).length;

  const onOpenChange = () => {
    getCompanyRole();
  };

  const onClickMenu = (e) => {
    const { key } = e;
    // menu 入口
    // 无公司user_info.company_id === 0  0 申请
    // 有公司未申请供应商：(company_role & 1) === 0 && supplier_is_examine === 2 companyRole === 2 申请
    // 有公司已申请供应商 - 待审核：(company_role & 1) === 0 && supplier_is_examine === 1 companyRole === 3 待审核
    // 有公司已申请供应商 - 审核未通过：(company_role & 1) === 0 && supplier_is_examine === 3 companyRole === 4 待审核
    // 有公司正式供应商：(company_role & 1) === 1 companyRole === 1 去中心
    // 有公司且是采购商，不是供应商 company_role === 2 companyRole === 5 申请
    if (key === 'supplier') {
      if ([0, 2, 5, 3, 4].includes(companyRole)) {
        if ([3, 4].includes(companyRole)) {
          setRoleText($t('Check the progress of application'));
          navigate('/supplier/apply');
        } else {
          setRoleText($t('Apply to be a Supplier'));
          open();
        }
        // navigate('/supplier/apply');
      } else if (companyRole === 1) {
        setRoleText($t('Supplier Center'));
        // navigate('/supplier/list');
        // navigate('/buyers/main');
        navigate('/supplier/front');
      } else { }
    } else if (key === 'buyers') {
      navigate('/buyers/front');
      // navigate('/buyers/index');
    } else {
      navigate(key);
    }
  };

  useEffect(() => {
    if (!storage.get('token')) return;
    getCompanyRole();
  });

  const getCompanyRole = () => {
    // let value = company_info.company_role & 1;
    // let supplier_is_examine = company_info.supplier_is_examine;
    // let roleType = (value === 1) ? 1 : 2;
    if (user_info.company_id === 0) { // 0 没公司 申请
      setCompanyRole(0);
      setRoleText($t('Apply to be a Supplier'));
    } else {
      // 有公司，看是否是供应商
      let value = company_info?.company_role & 1;
      let supplier_is_examine = company_info?.supplier_is_examine;
      let roleType = (value === 1) ? 1 : 2;
      // 不是供应商
      if (roleType === 2) {
        // if (company_info.company_role === 2) {
        //   // 只有采购商
        //   setCompanyRole(5);
        // } else {
        if ([1, 4].includes(supplier_is_examine)) {
          // 审批中
          setCompanyRole(3);
          setRoleText($t('Check the progress of application'));
        } else if (supplier_is_examine === 3) {
          // 拒绝
          setCompanyRole(4);
          setRoleText($t('Check the progress of application'));
        } else if (supplier_is_examine === 2) {
          // 新申请
          // setCompanyRole(2);
          // setRoleText('申请成为供应商');

          // 是采购商新申请
          if (company_info.company_role === 2) { // 是采购商，要回显
            setCompanyRole(5);
            // const supplierApplyInfo = await getSupplierApplyInfo();
            // return supplierApplyInfo;
          } else {
            // 新申请
            setCompanyRole(2);
            // setRoleText($t('Apply to be a Supplier'));
          }
          setRoleText($t('Apply to be a Supplier'));
        }
        // }
      } else if (roleType === 1) {
        // 是供应商
        setCompanyRole(1);
        setRoleText($t('Supplier Center'));
        // 已申请并审批过(已生成供应商id)，该情况不会进入该页面，进入供应商中心页
        // console.log('您已经是供应商');
      } else { }

    }
  };

  if (!token || AUTH_PAGES.includes(location.pathname)) return null;

  return (
    <div className='page-header_menu'>
      <div><PortalMenu isSupplier={companyRole === 1} applyText={roleText} onApply={() => onClickMenu({ key: 'supplier' })} onOpenChange={onOpenChange} /></div>
      <div><Link title={$t('Allocation Center')} to='/allocations/center' className='flex-align-center'><img src={STATIC_RESOURCE + '/cp_gsp/allocations/allocation.png'} width={20} height={20} alt='' /></Link></div>
      <div><Link title={$t('Cart')} to='/cart'><Badge style={{ transform: 'scale(.85)', padding: '0 2px' }} count={formatList || 0} size='small' offset={[6, -3]} className='flex-align-center'><img src={STATIC_RESOURCE + '/cp_gsp/header/shop.png'} width={20} height={20} alt='' /></Badge></Link></div>
      <div><Link title={$t('Collect List')} to='/favorites' className='flex-align-center'><img src={STATIC_RESOURCE + '/cp_gsp/header/plan.png'} width={20} height={20} alt='' /></Link></div>
      <div><NoticeHeader /></div>
      {SupplierApplyModal}
    </div>
  );
}